/**
 * EL NOMBRE DE CADA VOZ, EN EL IDIOMA DEL LECTOR (13-sep-2026, /traducir-web).
 *
 * Los datos (canalizaciones.json, rayos.js, ORDEN_ENTIDADES) nombran a las
 * entidades en español —«María Magdalena», «Los Ángeles», «Metatrón»— y así
 * tiene que seguir siendo: es la clave con la que se busca, se filtra y se
 * colorea. Pero lo que el lector VE va en su idioma (Mary Magdalene, Marie-
 * Madeleine, مريم المجدلية): el glosario fija la forma de cada nombre en cada
 * lengua, y aquí se traduce solo al pintarlo.
 *
 * Cada entidad tiene un identificador corto y estable; de él salen las claves
 * de texto:  section.<id> = el nombre · rayo.<id> = el nombre de su rayo ·
 * voz.rel_<id> = el parentesco o atributo · voz.pres_<id> = cómo se presenta.
 */
export const ID_VOZ = {
  'Jeshua': 'jeshua',
  'María': 'madre',
  'María Magdalena': 'magdalena',
  'Ana': 'abuela',
  'Miguel': 'miguel',
  'Gabriel': 'gabriel',
  'Rafael': 'rafael',
  'Uriel': 'uriel',
  'Chamuel': 'chamuel',
  'Jofiel': 'jofiel',
  'Zadquiel': 'zadquiel',
  'Metatrón': 'metatron',
  'Los Ángeles': 'angeles',
  'Los Esenios': 'esenios'
};

/** El nombre de la voz como lo ve el lector. Si no está en la tabla (una voz
 *  nueva del corpus), se muestra tal cual: nunca una clave cruda. */
export const nombreVoz = (entidad, t) => {
  const id = ID_VOZ[entidad];
  return id ? t('section.' + id) : entidad;
};

/**
 * El nombre CORTO de la voz, para las tarjetas pequeñas donde el largo parte en
 * dos líneas y descuadra la fila (Faina, 21-10-2026: «M. Magdalena»). Si la voz
 * no tiene nombre corto, se usa el de siempre.
 */
export const nombreVozCorto = (entidad, t) => {
  const id = ID_VOZ[entidad];
  if (!id) return entidad;
  /* La clave ya existía y está traducida a los 55 idiomas: es la misma que usa
     la ficha de las voces. */
  if (entidad === 'María Magdalena') return t('voz.corto_magdalena');
  return t('section.' + id);
};

/** Cualquier texto de la voz (rayo, relación, presentación) por su familia de clave. */
export const textoVoz = (familia, entidad, t, siNo = '') => {
  const id = ID_VOZ[entidad];
  return id ? t(familia + id) : siNo;
};
